// extracted by mini-css-extract-plugin
export default {"page":"CustomersPage_page__kMFpE","container":"CustomersPage_container__fltQu"};